import 'reflect-metadata';
import { cloneMap, valuesOfMap } from '../core';

export type MetaMap<T> = Map<string, T>;

export function getMetadata<T>(metadataKey: any, target: object, propertyKey?: string | symbol): T {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return Reflect.getMetadata(metadataKey, target, propertyKey);
}

export function cloneMetaMap<T>(metaMap: MetaMap<T>): MetaMap<T> {
  function valueCloner<S>(it: S): S {
    if (it instanceof Array) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      return it.slice();
    }
    return it;
  }

  return cloneMap(metaMap, valueCloner);
}

export function buildMetaMap<T>(metadataKey: any, target: object, propertyKey: string, metadata: T): MetaMap<T> {
  const metaMap = getMetadata<MetaMap<T>>(metadataKey, target) ?? new Map<string, T>();
  const clonedMetaMap = cloneMetaMap(metaMap);
  clonedMetaMap.set(propertyKey, metadata);
  return clonedMetaMap;
}

export function getMetaMap<T>(metadataKey: any, target: object): MetaMap<T> {
  return getMetadata<MetaMap<T>>(metadataKey, target) ?? new Map<string, T>();
}

export function getMetaMapValues<T>(metadataKey: any, target: object): T[] {
  return valuesOfMap(getMetaMap<T>(metadataKey, target));
}

export function defineMetaMap<T>(metadataKey: any, metaMap: MetaMap<T>, target: any) {
  Reflect.defineMetadata(metadataKey, metaMap, target);
}

export function buildAndDefineMetaMap<T>(metadataKey: any, target: any, propertyKey: string, metadata: T): MetaMap<T> {
  const metaMap = buildMetaMap(metadataKey, target, propertyKey, metadata);
  defineMetaMap(metadataKey, metaMap, target);
  return metaMap;
}
